import { useForm } from 'react-hook-form'
import {
    Select,
    FormErrorMessage, FormLabel, FormControl, Input,
    Button, Flex, useDisclosure, Box, useColorModeValue, Spacer,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Switch,
} from '@chakra-ui/react'
import React, {useState} from "react";
import {useAuthHeader} from "react-auth-kit";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {DatePicker} from '@gsebdev/react-simple-datepicker';

export default function RateCreate() {
    const textColor = useColorModeValue("gray.200", "white");
    const token = useAuthHeader();
    const [rateResponse, setRateResponse] = useState('')
    const [showError, setShowError] = useState(null)
    const [selected, setSelected] = useState(true)
    const [selected2, setSelected2] = useState(true)
    const [selected3, setSelected3] = useState(true)
    const navigate = useNavigate();
    const {
        handleSubmit,
        register,
        setValue,
        formState: { errors, isSubmitting },
    } = useForm()
    const { isOpen, onOpen, onClose } = useDisclosure()

    const toggleSelect = () => {
        setSelected(!selected)
    }
    const toggleSelect2 = () => {
        setSelected2(!selected2)
    }
    const toggleSelect3 = () => {
        setSelected3(!selected3)
    }

    const toggle = () => {
        onClose()
        navigate(`/admin_area/rates`);
    }

    const toggleShow = () => {
        setShowError(true)
    }

    const onchangeFrom = ({target}) => {
        let year = target.value.split("/")[2]
        let month = target.value.split("/")[0]
        let day = target.value.split("/")[1]
        setValue('active_from', year + '-' + month + '-' + day + "T00:00:00")
    }

    const onchangeTo = ({target}) => {
        let year = target.value.split("/")[2]
        let month = target.value.split("/")[0]
        let day = target.value.split("/")[1]
        setValue('active_to', year + '-' + month + '-' + day + "T00:00:00")
    }

    async function onSubmit(values) {
        try {
            const newData = await createRate(values, token());
            setRateResponse(newData)
            onOpen()
        } catch (e) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    alert(JSON.stringify(e.response.data, null, 2))
                    resolve()
                }, 1000)
            })
        }
    }

    return (
        <Flex direction='column' pt={{ base: "150px", md: "75px" }}>

            <Box w='100%' mb='20px'>
                <Flex maxW='500px'>
                    <Button colorScheme='teal' type='submit' onClick={() => {navigate(`/admin_area/rates`)}}>
                        Назад
                    </Button>
                    <Spacer/>
                    <Button colorScheme='teal' type='submit' onClick={() => {
                        setValue('active_from', "2023-09-14T00:00:00")
                        setValue('active_to', null)
                        setValue('currency_from', "RUB")
                        setValue('currency_to', "TJS")
                        setValue('fx_provider', "superprovider")
                        setValue('rate', "98.3")
                    }}>
                        Выбрать шаблон
                    </Button>
                </Flex>
            </Box>

            <Box
                border='1px'
                borderRadius='5px'
                borderColor={textColor}
                maxW='500px'
                w='100%'
                p={4}
            >

                <form onSubmit={handleSubmit(onSubmit)}>
                    <FormControl isInvalid={errors.active_from}>
                        <FormLabel htmlFor='active_from'>Время начала активности курса</FormLabel>
                        <DatePicker
                            id='active_from'
                            onChange={onchangeFrom}
                            value={'01/02/2023'}
                        />
                        <FormErrorMessage>
                            {errors.active_from && errors.active_from.message}
                        </FormErrorMessage>
                    </FormControl>

                    <FormControl isInvalid={errors.active_to}>
                        <FormLabel mt={"10px"} htmlFor='active_to'>Время завершения активности курса</FormLabel>
                        <DatePicker
                            id='active_to'
                            onChange={onchangeTo}
                            value={'01/02/2023'}
                        />
                        <FormErrorMessage>
                            {errors.active_to && errors.active_to.message}
                        </FormErrorMessage>
                    </FormControl>

                    <FormControl isInvalid={errors.currency_from}>
                        <FormLabel mt={"10px"} htmlFor='parent_card'>Перевод валюты из</FormLabel>
                        <label htmlFor="normal-switch">
                            <Switch
                                id="normal-switch"
                                colorScheme='teal'
                                onChange={toggleSelect}
                                checked={selected}
                                className="react-switch"
                            />
                            <span> {selected ? ' select' : ' input'}</span>
                        </label>
                        {selected
                            ? <Select
                                id='currency_from'
                                {...register('currency_from', {
                                    required: 'This is required'
                                })}
                            >
                                <option value='RUB'>RUB</option>
                                <option value='USDT'>USDT</option>
                                <option value='KGS'>KGS</option>
                                <option value='TJS'>TJS</option>
                                <option value='UZS'>UZS</option>
                                <option value='USD'>USD</option>
                                <option value='EUR'>EUR</option>
                            </Select>
                            : <Input
                                autoFocus={true}
                                id='currency_from'
                                placeholder='RUB TJS WTF'
                                {...register('currency_from', {
                                    required: 'This is required',
                                })}
                            />
                        }

                        <FormErrorMessage>
                            {errors.currency_from && errors.currency_from.message}
                        </FormErrorMessage>
                    </FormControl>

                    <FormControl isInvalid={errors.currency_to}>
                        <FormLabel mt={"10px"} htmlFor='parent_card'>Перевод валюты в</FormLabel>
                        <label htmlFor="normal-switch">
                            <Switch
                                id="normal-switch"
                                colorScheme='teal'
                                onChange={toggleSelect2}
                                checked={selected2}
                                className="react-switch"
                            />
                            <span> {selected2 ? ' select' : ' input'}</span>
                        </label>
                        {selected2
                            ? <Select
                                id='currency_to'
                                {...register('currency_to', {
                                    required: 'This is required'
                                })}
                            >
                                <option value='RUB'>RUB</option>
                                <option value='USDT'>USDT</option>
                                <option value='KGS'>KGS</option>
                                <option value='TJS'>TJS</option>
                                <option value='UZS'>UZS</option>
                                <option value='USD'>USD</option>
                                <option value='EUR'>EUR</option>
                            </Select>
                            : <Input
                                autoFocus={true}
                                id='currency_to'
                                placeholder='RUB TJS WTF'
                                {...register('currency_to', {
                                    required: 'This is required',
                                })}
                            />
                        }
                        <FormErrorMessage>
                            {errors.currency_to && errors.currency_to.message}
                        </FormErrorMessage>
                    </FormControl>

                    <FormControl isInvalid={errors.fx_provider}>
                        <FormLabel mt={"10px"} htmlFor='parent_card'>Провайдер</FormLabel>
                        <label htmlFor="normal-switch">
                            <Switch
                                id="normal-switch"
                                colorScheme='teal'
                                onChange={toggleSelect3}
                                checked={selected3}
                                className="react-switch"
                            />
                            <span> {selected3 ? ' select' : ' input'}</span>
                        </label>
                        {selected3
                            ? <Select
                                id='fx_provider'
                                {...register('fx_provider', {
                                    required: 'This is required'
                                })}
                            >
                                <option value='mtsbank'>mtsbank</option>
                                <option value='superprovider'>superprovider</option>
                            </Select>
                            : <Input
                                autoFocus={true}
                                id='fx_provider'
                                placeholder='mtsbank'
                                {...register('fx_provider', {
                                    required: 'This is required',
                                })}
                            />
                        }
                        <FormErrorMessage>
                            {errors.fx_provider && errors.fx_provider.message}
                        </FormErrorMessage>
                    </FormControl>

                    <FormControl isInvalid={errors.rate}>
                        <FormLabel mt={"10px"} htmlFor='parent_card'>Курс</FormLabel>
                        <Input
                            id='rate'
                            placeholder='98.3'
                            {...register('rate', {
                                required: 'This is required',
                            })}
                        />
                        <FormErrorMessage>
                            {errors.rate && errors.rate.message}
                        </FormErrorMessage>
                    </FormControl>

                    <Button mt={4} colorScheme='teal' isLoading={isSubmitting} type='submit'>
                        Создать новый курс
                    </Button>
                </form>

            </Box>
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Создание курса</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {rateResponse.info
                            ? rateResponse.info
                            : <pre><p>Курс создан</p>{JSON.stringify(rateResponse, null, 2)}</pre>
                        }
                        <br/>
                        <br/>
                        {showError
                            ? <pre-wrap>{JSON.stringify(rateResponse.error, null, 2)}</pre-wrap>
                            : ''
                        }
                    </ModalBody>
                    <ModalFooter>
                        {rateResponse.error
                            ? <Button colorScheme='red' onClick={toggleShow}>Подробности</Button>
                            : ''
                        }
                        <Spacer/>
                        <Button colorScheme='blue' onClick={toggle}>Закрыть</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Flex>
    )
}


async function createRate(params, token) {
    try {
        let raw = {
            active_from: params.active_from,
            active_to: params.active_to,
            currency_from: params.currency_from,
            currency_to: params.currency_to,
            fx_provider: params.fx_provider,
            rate: params.rate,
        };

        const response = await axios.post(`/api/v1/fx_rate`, raw,
            {headers: {Authorization: token}})
        return await response.data
    } catch (e) {
        if (e.response) {
            let error = {}
            error['info'] = "Невозможно создать, такой курс уже существует"
            if ( Object.assign(e.response.data).errors ) {
                error['error'] = Object.assign(e.response.data).errors
            } else {
                error['error'] = e.response.data
            }

            return error
        }
    }
}
